import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

const { white, secondary } = colors;
/** Label on saturated backgrounds; `white.main` in dark palette is grey (#e3e3e3). */
const onColor = "#ffffff";
const { size } = typography;

const contained = {
  base: {
    backgroundColor: white.main,
    minHeight: pxToRem(37),
    color: colors.background.default,
    padding: `${pxToRem(9)} ${pxToRem(24)}`,

    "&:hover": {
      backgroundColor: white.main,
    },

    "&:active, &:active:focus, &:active:hover": {
      opacity: 0.85,
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(29),
    padding: `${pxToRem(6)} ${pxToRem(18)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(44),
    padding: `${pxToRem(12)} ${pxToRem(64)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    backgroundColor: colors.primary.main,
    color: `${onColor} !important`,

    "&:hover": {
      backgroundColor: colors.primary.focus,
      color: `${onColor} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.primary.focus,
      color: `${onColor} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: colors.primary.main,
      color: `${onColor} !important`,
      opacity: 0.9,
    },
  },

  secondary: {
    backgroundColor: secondary.main,
    color: `${onColor} !important`,

    "&:hover": {
      backgroundColor: secondary.main,
      color: `${onColor} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: secondary.focus,
      color: `${onColor} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: secondary.main,
      color: `${onColor} !important`,
      opacity: 0.9,
    },
  },

  success: {
    backgroundColor: colors.success.main,
    color: `${onColor} !important`,

    "&:hover": {
      backgroundColor: colors.success.main,
      color: `${onColor} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.success.focus,
      color: `${onColor} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: colors.success.main,
      color: `${onColor} !important`,
      opacity: 0.9,
    },
  },

  warning: {
    backgroundColor: colors.warning.main,
    color: `${onColor} !important`,

    "&:hover": {
      backgroundColor: colors.warning.main,
      color: `${onColor} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.warning.focus,
      color: `${onColor} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: colors.warning.main,
      color: `${onColor} !important`,
      opacity: 0.9,
    },
  },

  error: {
    backgroundColor: colors.error.main,
    color: `${onColor} !important`,

    "&:hover": {
      backgroundColor: colors.error.main,
      color: `${onColor} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.error.focus,
      color: `${onColor} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: colors.error.main,
      color: `${onColor} !important`,
      opacity: 0.9,
    },
  },

  dark: {
    backgroundColor: colors.dark.main,
    color: `${onColor} !important`,

    "&:hover": {
      backgroundColor: colors.dark.focus,
      color: `${onColor} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.dark.focus,
      color: `${onColor} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: colors.dark.main,
      color: `${onColor} !important`,
      opacity: 0.9,
    },
  },

  info: {
    backgroundColor: colors.info.main,
    color: `${onColor} !important`,

    "&:hover": {
      backgroundColor: colors.info.focus,
      color: `${onColor} !important`,
    },

    "&:focus:not(:hover)": {
      backgroundColor: colors.info.focus,
      color: `${onColor} !important`,
    },

    "&:active, &:active:focus, &:active:hover": {
      backgroundColor: colors.info.main,
      color: `${onColor} !important`,
      opacity: 0.9,
    },
  },
};

export default contained;
